import React, { useState, useEffect } from "react";

import { useNavigate } from 'react-router-dom';
import * as S from '../scss/theme';
import './MainPage_first.scss';

import Footer from '../Footer';

import 'aos/dist/aos.css';
import AOS from 'aos';
import logo1_red_text from '../images/logo/logo1_red_text.png';
// import aboutIgonMp3 from '../images/mp3/aboutIgong.mp3';
import { useDispatch } from "react-redux";
import { setActiveLink } from "../reduxToolkit/reduxIgong";
import HongButton from "../comm/HongButton";
import HongAudioPlayer from '../audio/HongAudioPlayer';
import fncS4 from '../mymod/commFunction4';


const MainPage_first = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [audioSrc, setAudioSrc] = useState(null);
    const [isAutoPlay, setIsAutoPlay] = useState(false);


    useEffect(() => {
        AOS.init({
            duration: 1500,
            easing: 'ease-in-out',
            once: true,  
            mirror: true,  // 🚀 위에서 아래, 아래에서 위로 이동할 때도 실행
        });

        // 🚀 AOS를 주기적으로 업데이트하여 새로운 요소를 감지
        const interval = setInterval(() => {
            AOS.refresh();
        }, 1000); // 1초마다 새로고침

        return () => clearInterval(interval); // 메모리 누수를 방지하기 위해 정리
    }, []);


    function handleLoginWhere() {
        navigate('/loginWhere');
        dispatch(setActiveLink('진단하기'));
    }

    function handleMain() {
        navigate('/main');
        dispatch(setActiveLink('아이공'));
    }

    function handleLive() {
        navigate('/live');
        dispatch(setActiveLink('LIVE 특강'));
    }

    function handleShop() {
        navigate('/shop');
        dispatch(setActiveLink('SHOP'));
    }


    
    function handleLogin() {
        navigate('/loginWhere');
    }
 
    function handleSingup() {
      
            navigate('/loginWhere');
     }

     function handleConsltant() {

            navigate('/adminsions_consultant');
            // navigate('/ad_adminsions_consultant_app');

     }

    //---------------------------------------------------------재생
    // 마우스를 한 번 클릭해야만 오디오가 재생되는 이유는 브라우저의 자동 재생(autoplay) 정책 때문입니다.
    // 크롬·사파리 등 대부분의 브라우저는 사용자의 명시적 상호작용 없이 오디오/비디오 자동재생을 금지합니다.
    // 한번은 클릭해야 재생 됨

    async function fncPlayMp3() {
        const mp3FileName = 'aboutIgong.mp3';
        let fullPath = '';
        fullPath = await fncS4.getS3PathLong(`mp3/aboutIgong/${mp3FileName}`);
    
        setAudioSrc(fullPath);
        setIsAutoPlay(true);
        setShowPopup(true);
    }

   function fncPlayClose() {
        setShowPopup(false); 
        setIsAutoPlay(false);
        setAudioSrc(null);
   }
  
    //========================================================
    return (
        <S.Section_wide>
            <div className="MainPage_first">
                <div className='wrap-main'>
                <section className='sec-main1'>

                    {/* <article className="art-logo">
                        <img className='img-logo' src={logo1_red_text} alt="logo" />
                    </article> */}

                    <article
                        className="art-logo"
                        // onMouseEnter={() => fncPlayMp3()}
                        // onMouseLeave={() => {setShowPopup(false); setIsAutoPlay(false);setAudioSrc(null);}}
                        >
                        <img className="img-logo" src={logo1_red_text} alt="logo" />
                        {showPopup && (
                            <div className="popup-info">
                               
                              
                                <div className="title">
                                        초중고 유형적성 기반<br />
                                        학업역량 종합 진단분석<br />
                                        맞춤코칭 프로그램<br />
                                </div>
                                <div className="content">
                                    <strong>아이공</strong>은 우리 아이들의 전반적인 공부력을 진단 및 
                                    분석 후 <strong>“왜, 무엇부터, 어떻게 해야 하는지”</strong>를 이해
                                    하고 이행하는데 초점을 맞추고 있습니다.<br />
                                    특히나, 진로직업에 대한 목표의식과 집중력과 몰입
                                    능력의 향상을 위한 문해력의 체계적인 훈련법 그리
                                    고 자기주도력은 어떻게 만들어 가느냐에 대한 루틴
                                    과 습관 등 <strong>유형별 맞춤 공부법과 학업역량 로드맵</strong>
                                    을 제공하고 있습니다.<br />
                                    우선, 진단 완료 후 제공되는 레포트를 통해 우리 아
                                    이의 면면을 자세히 확인해 본 후 
                                    막연하게 느껴졌던 <strong>“공부력과 학업역량 전반의 밸
                                    런스”</strong>를 제공하는 맞춤미션을 통해 <strong>문제원인 지점
                                    부터 우선 터치해보며 변화하고 진화해 나아가는 시
                                    간</strong>을 필히 가져볼 것을 권합니다.
                                </div>

                                 <HongButton
                                    className="h-btn-gray btn-audio-close"
                                    onClick={fncPlayClose}   >
                                    닫기
                                </HongButton>
                            </div>
                        )}

                        <HongButton
                            className="h-btn-dark  btn-audio-play"
                            onClick={fncPlayMp3}>
                            오디오로 소개 듣기
                        </HongButton>
                    
                    </article>

                   

                    <article className="art-memu">
                        {/* 첫 번째 줄 */}
                        <div className="button-row first-row">
                            <button className="button" onClick={handleLoginWhere}>진단하기</button>
                            <div className="button-div"></div>
                            <button className="button" onClick={handleMain}>아이공</button>
                            <div className="rect-vert"></div>
                        </div>
                        
                        {/* 두 번째 줄 (4rem 아래) */}
                        <div className="button-row second-row">
                            <button className="button" onClick={handleLive}>LIVE 특강</button>
                            <div className="button-div"></div>
                            <button className="button" onClick={handleConsltant}>협력|문의</button>
                        </div>
                    </article>

                    {/* <article className="art-login">
                        <HongButton className="h-btn-red btn" onClick={handleLogin}>로그인</HongButton>
                        <HongButton className="h-btn-blue btn" onClick={handleSingup}>회원가입</HongButton>
                    </article> */}

                </section>


              
                <section className='bg_none'>
                    <Footer />
                </section>

                 <div className='box-menu'>

                <HongAudioPlayer 
                    audioSrc={audioSrc} 
                    autoPlay={isAutoPlay} 
                    onPlayCallback={() => console.log("Dynamic audio played")} 
                />
                </div>

                </div>
            </div>
        </S.Section_wide>
    );
};

export default MainPage_first;
